import { useDispatch } from 'react-redux';
import { cleanAggregationsAction } from '../../containers/App/actions';

export default function useResetOptions() {
  const dispatch = useDispatch();

  const resetOptions = fieldName => {
    dispatch(cleanAggregationsAction(fieldName));
  };
  return resetOptions;
}
